import { Route, Routes } from "react-router-dom"
import NotFound404 from "../pages/NotFound404"
import RequireAuth from "../components/Authentication/RequireAuth";
import PersistLogin from "../components/Authentication/PersistLogin";
import ChartPage from "../pages/ChartPage";
import AdminViewRequest from "../pages/AdminViewRequest";
import ReportsPage from "../pages/ReportsPage";
import ArchivedListPage from "../pages/ArchivedListPage";

const AdminRouter = () => {
    return (
        <Routes>
            <Route element={<PersistLogin />}>
                <Route element={<RequireAuth allowedRoles={["500"]} />}>                    
                    <Route path="/" element={<ChartPage />} />
                    <Route path="/view-request" element={<AdminViewRequest />} />
                    <Route path="/archived" element={<ArchivedListPage />} />
                    <Route path="/reports" element={<ReportsPage />} />
                    <Route path="/reports/slip-chart" element={<ChartPage />} />
                    <Route path="*" element={<NotFound404 />} />
                </Route>
            </Route>
        </Routes>
    )
}

export default AdminRouter;